export default "__VITE_ASSET__Bxga1jf1__"